<app-header></app-header>

<div class="wrapper">

    <div class="banner-img-name">

        <div class="main" style="padding-bottom: 0;">
            <h2>Application Form</h2>
        </div>

    </div>

    <section class="main">

        <div class="info">

            <h3>You are applying on the e-Visa</h3>

            <p>Citizens of ECOWAS member states and nationals of countries with visa abolition agreements with Nigeria
                are exempt from visa requirements. However, they are required to complete both landing and exit cards.
            </p>

        </div>

        <div class="form_main">

            <ul id="progressbar">

                <ng-container *ngFor="let applicationStepObject of applicationStepsList;">

                    <li [id]="applicationHighestStage >= applicationStepObject.count && applicationStage !== applicationStepObject.count ? applicationStepObject.id + '-tick' : applicationStepObject.id"
                        [ngClass]="applicationHighestStage >= applicationStepObject.count ? 'active allow-cursor' : 'not-allow-cursor'"
                        (click)="applicationHighestStage >= applicationStepObject.count ? openFieldSet(applicationStepObject.count, $event) : ''">
                        <p>{{applicationStepObject.label}}</p>
                    </li>

                </ng-container>

            </ul>

            <fieldset *ngIf="applicationStage === constants.GENERAL_INFO_STEP" class="passport_type">

                <div class="step_info">
                    <span>Step 1: {{applicationStepsList[0].label}}</span>
                </div>

                <form #generalDetailsForm="ngForm"
                    (ngSubmit)="generalDetailsForm.form.valid && openPersonalDetailsForm($event)"
                    name="generalDetailsForm" autocomplete="off" id="msform" error-focus>

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="generalDetailsFormObject.hasFieldValueChanged" #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="generalDetailsFormObject.callableFunctionName" #callableFunctionName="ngModel">

                    <div class="grid-passport">

                        <div class="grid-box">

                            <div class="grid-two">

                                <div class="form_box">
                                    <label class="fieldlabels">1. Nationality<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <mat-select name="nationality"
                                            [(ngModel)]="generalDetailsFormObject.nationality" #nationality="ngModel"
                                            class="effect" required="required"
                                            (ngModelChange)="storeVisaClassList(true); storePassportList(true);"
                                            (openedChange)="utils.checkHasMatValueChanged($event, generalDetailsFormObject, 'nationality');">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="nationalitySelectService.selectFilterControl"
                                                    noEntriesFoundLabel="No data found"
                                                    placeholderLabel="Search"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option
                                                *ngFor="let nationality of nationalitySelectService.filteredOptions | async"
                                                [value]="nationality.value">{{nationality.text}}</mat-option>
                                        </mat-select>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Choose the country of
                                            citizenship, as it appears on your passport. The country of citizenship is
                                            required to complete the application.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="generalDetailsForm.submitted && nationality.invalid">
                                        <span *ngIf="nationality.errors.required">
                                            Nationality is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">2. Class Of Visa<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <mat-select name="visaClass" [(ngModel)]="generalDetailsFormObject.visaClass"
                                            #visaClass="ngModel" class="effect" required="required"
                                            (ngModelChange)="setAgeRestrictionObject(); setSelectedVisaClassObject()"
                                            (openedChange)="utils.checkHasMatValueChanged($event, generalDetailsFormObject, 'visaClass');">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="visaClassSelectService.selectFilterControl"
                                                    noEntriesFoundLabel="No data found"
                                                    placeholderLabel="Search"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option
                                                *ngFor="let visaClass of visaClassSelectService.filteredOptions | async"
                                                [value]="visaClass.value">{{visaClass.text}}</mat-option>
                                        </mat-select>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Choose class of
                                            visa.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="generalDetailsForm.submitted && visaClass.invalid">
                                        <span *ngIf="visaClass.errors.required">
                                            Class Of Visa is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">3. Passport Type<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <mat-select name="passportType"
                                            [(ngModel)]="generalDetailsFormObject.passportType" #passportType="ngModel"
                                            class="effect" required="required" (ngModelChange)="fetchVisaFeeDetails();"
                                            (openedChange)="utils.checkHasMatValueChanged($event, generalDetailsFormObject, 'passportType');">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="passportSelectService.selectFilterControl"
                                                    noEntriesFoundLabel="No data found" placeholderLabel="Search"
                                                    autocomplete="off"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option
                                                *ngFor="let passportType of passportSelectService.filteredOptions | async"
                                                [value]="passportType.value">{{passportType.text}}</mat-option>
                                        </mat-select>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Choose passport type
                                            field.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="generalDetailsForm.submitted && passportType.invalid">
                                        <span *ngIf="passportType.errors.required">
                                            Passport Type is required!
                                        </span>
                                    </span>
                                </div>

                            </div>

                        </div>

                        <div class="grid-box">

                            <div *ngIf="isShowFeesSection === true" class="fee">

                                <div class="row_box pd12" *ngIf="feeDetailsObject.isGratis === constants.TRUE">
                                    <div class="green_band_gratis">
                                        <span class="green_band_gratis_msg">In view of the existing bilateral
                                            agreements/arrangements, your VISA is on gratis basis and no fee will be
                                            charged.</span>
                                    </div>
                                </div>

                                <div>
                                    Visa Fee : <span>{{feeDetailsObject.currencySymbol}}
                                        {{feeDetailsObject.visaFee}}</span>
                                </div>

                                <!-- <div>
                                    Processing Fee : <span>{{feeDetailsObject.currencySymbol}} {{feeDetailsObject.processingCharges}}</span>
                                </div> -->

                                <div
                                    *ngIf="feeDetailsObject.isGratis === constants.FALSE && feeDetailsObject.addOnCharges > 0">
                                    eVAC Fee : <span>{{feeDetailsObject.currencySymbol}}
                                        {{feeDetailsObject.addOnCharges}}</span>
                                </div>

                                <div>
                                    <b>Total Fee :</b> <span><b>{{feeDetailsObject.currencySymbol}}
                                            {{feeDetailsObject.totalCharges}}</b></span>
                                </div>

                            </div>

                        </div>

                    </div>

                    <input type="button" (click)="openDashboardPage()" class="action-button-previous back_btn mt20"
                        value="Back" />

                    <input type="submit" [value]="isShowApplicationIdMessage === true ? 'Save & Continue' : 'Continue'"
                        class="action-button custom_btn" />

                </form>

            </fieldset>

            <fieldset *ngIf="applicationStage === constants.PERSONAL_INFO_STEP">

                <div class="step_info">
                    <span>Step 2: {{applicationStepsList[1].label}}</span>
                </div>

                <form #personalDetailsForm="ngForm"
                    (ngSubmit)="handlePersonalDetailsSubmit(personalDetailsForm, $event)" name="personalDetailsForm"
                    autocomplete="off" id="msform" errorFocus
                    [validateDateOfBirth]="['dateOfBirthDay', 'dateOfBirthMonth', 'dateOfBirthYear', serverDate, isAfricanCountry, ageFactorObject, generalDetailsFormObject.visaClass]"
                    [passportExpiryDate]="['passportExpiryDate']">

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="personalDetailsFormObject.hasFieldValueChanged" #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="personalDetailsFormObject.callableFunctionName" #callableFunctionName="ngModel">

                    <ng-template #instructions>

                        <ul>

                            <li>The information you provide must match the information on your passport. Any
                                discrepancies will cancel your visa application.</li>

                            <li>Each application form is meant for one person only. A separate application has to be
                                filled for each applicant.</li>

                            <li>Each passport must have a minimum validity of six months as of the date of submission of
                                the application.</li>

                            <li>Applicants are requested to verify their application details before making payment.</li>

                            <li>Applicants have an option to save their application if they choose not to pay online.
                            </li>

                            <li>Applicants have an option to save their application if they choose not to pay online.
                            </li>

                            <li>Letters(A-Z, a-z), Numbers (0-9), period(.) hyphen or dash(-), apostrophe (') and space
                                are the allowable characters for names.</li>

                        </ul>

                    </ng-template>

                    <div class="grid-one-third">

                        <div class="grid-onethird-box">

                            <details>

                                <summary>Instructions for Applicant </summary>

                                <div class="content">

                                    <ng-template [ngTemplateOutlet]="instructions"></ng-template>

                                </div>

                            </details>

                            <div class="grid-two reverse_col">

                                <div class="grid-two">

                                    <div class="form_box">
                                        <label class="fieldlabels">1. Title <span class="medatory">*</span></label>
                                        <div class="input_box">
                                            <select name="title" [identifyValueChange]="personalDetailsFormObject"
                                                [(ngModel)]="personalDetailsFormObject.title" #title="ngModel"
                                                class="effect" required="required" (ngModelChange)="setGender();">
                                                <option [value]="constants.BLANK">
                                                    {{constants.DEFAULT_SELECT_OPTION_LABEL}}</option>
                                                <option [value]="constants.MR">Mr.</option>
                                                <option [value]="constants.MRS">Mrs.</option>
                                                <option [value]="constants.MISS">Miss</option>
                                                <option [value]="constants.MS">Ms.</option>
                                                <option [value]="constants.MASTER">Master</option>
                                                <option [value]="constants.DR">Doctor</option>
                                                <option [value]="constants.PROF">Prof</option>
                                                <option [value]="constants.OTHER">Other</option>
                                            </select>
                                            <span class="icon_caret"><i class="fa fa-caret-down"
                                                    aria-hidden="true"></i></span>
                                            <span class="tooltip"><span class='tooltipArrow'></span></span>
                                            <span class="focus-border "><i></i></span>
                                        </div>
                                        <span class="alert-danger"
                                            *ngIf="personalDetailsForm.submitted && title.invalid">
                                            <span *ngIf="title.errors?.required">
                                                Title is required!
                                            </span>
                                        </span>
                                    </div>

                                    <div class="form_box ">
                                        <label class="fieldlabels">2. Surname <span class="medatory">*</span></label>
                                        <div class="input_box">
                                            <input type="text" name="lastName" hint
                                                [identifyValueChange]="personalDetailsFormObject"
                                                [(ngModel)]="personalDetailsFormObject.lastName" #lastName="ngModel"
                                                class="effect" required="required" minlength="2" maxlength="50"
                                                [pattern]="pattern.COMMON_FIELD_PATTERN"
                                                (ngInit)="utils.validateName(lastName, 'Surname', personalDetailsFormObject.lastName);"
                                                (blur)="utils.validateName(lastName, 'Surname', personalDetailsFormObject.lastName);">
                                            <span class="tooltip"><span class='tooltipArrow'></span>Enter your Surname.
                                            </span>
                                            <span class="focus-border "><i></i></span>
                                        </div>
                                        <span class="alert-danger"
                                            *ngIf="personalDetailsForm.submitted && lastName.invalid">
                                            <span *ngIf="lastName.errors?.required">
                                                Surname is required!
                                            </span>
                                            <span *ngIf="lastName.errors?.minlength">
                                                Surname should be of minimum 2 characters!
                                            </span>
                                            <span *ngIf="!lastName.errors?.minlength && lastName.errors?.pattern">
                                                Surname should start and end with an alphabet!
                                            </span>
                                            <span *ngIf="lastName.errors.hasError">
                                                {{lastName.errors.errorMessage}}
                                            </span>
                                        </span>
                                    </div>

                                    <div class="form_box ">
                                        <label class="fieldlabels">3. First Name <span class="medatory">*</span></label>
                                        <div class="input_box">
                                            <input type="text" name="firstName" hint
                                                [identifyValueChange]="personalDetailsFormObject"
                                                [(ngModel)]="personalDetailsFormObject.firstName" #firstName="ngModel"
                                                class="effect" required="required" minlength="2" maxlength="50"
                                                [pattern]="pattern.FIRST_NAME_FIELD_PATTERN"
                                                (ngInit)="utils.validateName(firstName, 'First name', personalDetailsFormObject.firstName);"
                                                (blur)="utils.validateName(firstName, 'First name', personalDetailsFormObject.firstName);">
                                            <span class="tooltip"><span class='tooltipArrow'></span>Enter your first
                                                name (given name). </span>
                                            <span class="focus-border"><i></i></span>
                                        </div>
                                        <span class="alert-danger"
                                            *ngIf="personalDetailsForm.submitted && firstName.invalid">
                                            <span *ngIf="firstName.errors?.required">
                                                First Name is required!
                                            </span>
                                            <span *ngIf="firstName.errors?.minlength">
                                                First Name should be of minimum 2 characters!
                                            </span>
                                            <span *ngIf="!firstName.errors?.minlength && firstName.errors?.pattern">
                                                First Name should start with alphabet and end with an alphabet or
                                                number!
                                            </span>
                                            <span *ngIf="firstName.errors.hasError">
                                                {{firstName.errors.errorMessage}}
                                            </span>
                                        </span>
                                    </div>

                                    <div class="form_box ">
                                        <label class="fieldlabels">4. Middle Name</label>
                                        <div class="input_box">
                                            <input type="text" name="middleName" hint
                                                [identifyValueChange]="personalDetailsFormObject"
                                                [(ngModel)]="personalDetailsFormObject.middleName" #middleName="ngModel"
                                                class="effect" minlength="2" maxlength="50"
                                                [pattern]="pattern.COMMON_FIELD_PATTERN"
                                                (ngInit)="utils.validateName(middleName, 'Middle name', personalDetailsFormObject.middleName);"
                                                (blur)="utils.validateName(middleName, 'Middle name', personalDetailsFormObject.middleName);">
                                            <span class="tooltip"><span class='tooltipArrow'></span>In the middle name
                                                field, enter your middle name and it is optional.</span>
                                            <span class="focus-border "><i></i></span>
                                        </div>
                                        <span class="alert-danger"
                                            *ngIf="personalDetailsForm.submitted && middleName.invalid">
                                            <span *ngIf="middleName.errors?.minlength">
                                                Middle Name should be of minimum 2 characters!
                                            </span>
                                            <span *ngIf="!middleName.errors?.minlength && middleName.errors?.pattern">
                                                Middle Name should start and end with an alphabet!
                                            </span>
                                            <span *ngIf="middleName.errors.hasError">
                                                {{middleName.errors.errorMessage}}
                                            </span>
                                        </span>
                                    </div>

                                    <div class="form_box ">
                                        <label class="fieldlabels">5. Date of Birth <span
                                                class="small_screen">(dd/mm/yyyy)</span> <span
                                                class="medatory">*</span></label>
                                        <div class="grid-date">
                                            <div class="input_box">
                                                <input type="text" name="dateOfBirthDay" hint numberOnly
                                                    [identifyValueChange]="personalDetailsFormObject"
                                                    [(ngModel)]="personalDetailsFormObject.dateOfBirthDay"
                                                    #dateOfBirthDay="ngModel" class="effect" required="required"
                                                    maxlength="2" placeholder="DD">
                                                <span class="tooltip"><span class='tooltipArrow'></span>The date of
                                                    birth is required to complete the application or to check the status
                                                    of your application. </span>
                                                <span class="focus-border "><i></i></span>
                                            </div>

                                            <div class="input_box">
                                                <select name="dateOfBirthMonth"
                                                    [identifyValueChange]="personalDetailsFormObject"
                                                    [(ngModel)]="personalDetailsFormObject.dateOfBirthMonth"
                                                    #dateOfBirthMonth="ngModel" class="effect" required="required">
                                                    <option *ngFor="let object of monthsList;" [value]="object.value">
                                                        {{object.text}}</option>
                                                </select>
                                                <span class="icon_caret"><i class="fa fa-caret-down"
                                                        aria-hidden="true"></i></span>
                                                <span class="tooltip"><span class='tooltipArrow'></span></span>
                                                <span class="focus-border "><i></i></span>
                                            </div>

                                            <div class="input_box">
                                                <input type="text" name="dateOfBirthYear" hint numberOnly
                                                    [identifyValueChange]="personalDetailsFormObject"
                                                    [(ngModel)]="personalDetailsFormObject.dateOfBirthYear"
                                                    #dateOfBirthYear="ngModel" class="effect" required="required"
                                                    minlength="4" maxlength="4" placeholder="YYYY">

                                                <span class="focus-border "><i></i></span>
                                            </div>
                                        </div>
                                        <span class="alert-danger"
                                            *ngIf="personalDetailsForm.submitted && (dateOfBirthDay.invalid || dateOfBirthMonth.invalid || dateOfBirthYear.invalid)">
                                            <span
                                                *ngIf="(dateOfBirthDay.errors?.required || dateOfBirthMonth.errors?.required || dateOfBirthYear.errors?.required)">
                                                Date of Birth is required!
                                            </span>
                                            <span *ngIf="dateOfBirthYear.errors?.minlength">
                                                Date of Birth's year should be of 4 digits!
                                            </span>
                                            <span
                                                *ngIf="!dateOfBirthYear.errors?.minlength && dateOfBirthDay.errors?.hasError">
                                                {{dateOfBirthDay.errors.errorMessage}}
                                            </span>
                                        </span>
                                    </div>

                                    <div class="form_box">
                                        <label class="fieldlabels">6. Place of Birth <span
                                                class="medatory">*</span></label>
                                        <div class="input_box">
                                            <input type="text" name="placeOfBirth" hint
                                                [identifyValueChange]="personalDetailsFormObject"
                                                [(ngModel)]="personalDetailsFormObject.placeOfBirth"
                                                #placeOfBirth="ngModel" class="effect" required="required" minlength="2"
                                                maxlength="20" [pattern]="pattern.COMMON_FIELD_PATTERN">
                                            <span class="tooltip"><span class='tooltipArrow'></span>Enter the city,
                                                town, village in which you were born is required to complete the
                                                application. If you do not know the city in which you were born, enter
                                                UNKNOWN.</span>
                                            <span class="focus-border "><i></i></span>
                                        </div>
                                        <span class="alert-danger"
                                            *ngIf="personalDetailsForm.submitted && placeOfBirth.invalid">
                                            <span *ngIf="placeOfBirth.errors?.required">
                                                Place of Birth is required!
                                            </span>
                                            <span *ngIf="placeOfBirth.errors?.minlength">
                                                Place of Birth should be of minimum 2 characters!
                                            </span>
                                            <span
                                                *ngIf="!placeOfBirth.errors?.minlength && placeOfBirth.errors?.pattern">
                                                Place of Birth should start and end with an alphabet!
                                            </span>
                                        </span>
                                    </div>

                                </div>

                                <div class="img_upload">

                                    <div class="img_box">

                                        <input type="hidden" name="passportImageData"
                                            [identifyValueChange]="personalDetailsFormObject"
                                            [(ngModel)]="personalDetailsFormObject.passportImageData"
                                            #passportImageData="ngModel" class="effect" required="required">

                                        <img [src]="isApplicantImageExist === true ? personalDetailsFormObject.passportImageData : 'assets/images/defaultImage.png'"
                                            class="cropped">

                                        <span
                                            (click)="openFileUploadModal(personalDetailsFormObject, 'passportImageData', 'passportImageFileType', true)"
                                            class="icon_image"><i class="fa fa-camera" aria-hidden="true"></i> </span>

                                    </div>
                                    <span class="alert alert-danger" role="alert"
                                        *ngIf="personalDetailsForm.submitted && passportImageData.invalid"
                                        style="text-align: center;">
                                        <span *ngIf="passportImageData.errors.required">
                                            Image is required!
                                        </span>
                                    </span>

                                </div>



                            </div>

                            <div class="grid-two reverse_col">

                                <div class="form_box">
                                    <label class="fieldlabels">7. Gender <span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <select name="gender" [identifyValueChange]="personalDetailsFormObject"
                                            [(ngModel)]="personalDetailsFormObject.gender" #gender="ngModel"
                                            class="effect" required="required">
                                            <option [value]="constants.BLANK">{{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                            </option>
                                            <option [value]="constants.MALE">Male</option>
                                            <option [value]="constants.FEMALE">Female</option>
                                        </select>
                                        <span class="icon_caret"><i class="fa fa-caret-down"
                                                aria-hidden="true"></i></span>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Choose your gender,
                                            either male or female or other. The gender is required to complete the
                                            application.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger" *ngIf="personalDetailsForm.submitted && gender.invalid">
                                        <span *ngIf="gender.errors?.required">
                                            Gender is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">8. Marital Status <span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <select name="maritalStatus" [identifyValueChange]="personalDetailsFormObject"
                                            [(ngModel)]="personalDetailsFormObject.maritalStatus"
                                            #maritalStatus="ngModel" class="effect" required="required">
                                            <option [value]="constants.BLANK">{{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                            </option>
                                            <option [value]="constants.SINGLE">Single</option>
                                            <option [value]="constants.MARRIED">Married</option>
                                            <option [value]="constants.WIDOWED">Widowed</option>
                                            <option [value]="constants.DIVORCED">Divorced</option>
                                        </select>
                                        <span class="icon_caret"><i class="fa fa-caret-down"
                                                aria-hidden="true"></i></span>
                                        <span class="tooltip"><span class='tooltipArrow'></span></span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="personalDetailsForm.submitted && maritalStatus.invalid">
                                        <span *ngIf="maritalStatus.errors?.required">
                                            Marital status is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">9. Passport Number <span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="passportNumber" alphaNumeric
                                            [identifyValueChange]="personalDetailsFormObject"
                                            [(ngModel)]="personalDetailsFormObject.passportNumber"
                                            #passportNumber="ngModel" class="effect" required="required" minlength="5"
                                            maxlength="50"
                                            (input)="personalDetailsFormObject.passportNumber = personalDetailsFormObject.passportNumber.toUpperCase()">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Enter your passport
                                            number as it appears on your passport. The passport number may contain
                                            numbers and/or characters. Please closely distinguish between the number
                                            zero and the letter O. The passport number is required to complete the
                                            application or to check the status of your application.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger" role="alert"
                                        *ngIf="personalDetailsForm.submitted && passportNumber.invalid">
                                        <span *ngIf="passportNumber.errors?.required">
                                            Passport Number is required!
                                        </span>
                                        <span *ngIf="passportNumber.errors?.pattern">
                                            Passport Number should start with an alphabet
                                        </span>
                                        <span *ngIf="passportNumber.errors?.minlength">
                                            Passport Number should be of minimum 5 digits!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">10. Passport Expiry Date(dd/mm/yyyy) <span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="passportExpiryDate"
                                            [identifyValueChange]="personalDetailsFormObject" mwlFlatpickr
                                            [minDate]="passportMinExpiryDate"
                                            [(ngModel)]="personalDetailsFormObject.passportExpiryDate"
                                            #passportExpiryDate="ngModel" class="effect" required="required"
                                            (blur)="utils.validateCalendarYear(passportExpiryDate, personalDetailsFormObject.passportExpiryDate);">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Your passport expiry
                                            should be more than 6 months.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert alert-danger" role="alert"
                                        *ngIf="personalDetailsForm.submitted && passportExpiryDate.invalid">
                                        <span *ngIf="passportExpiryDate.errors?.required">
                                            Passport Expiry Date is required!
                                        </span>
                                        <span *ngIf="passportExpiryDate.errors?.hasError">
                                            {{passportExpiryDate.errors.errorMessage}}
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">11. Do you have a Nigerian Passport?<span
                                                class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="hasNigerianPassport" [value]="false"
                                                [(ngModel)]="personalDetailsFormObject.hasNigerianPassport"
                                                class="infoyn" id="convictionsNo" required
                                                #nigerianPassport="ngModel" />
                                            <label for="convictionsNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="hasNigerianPassport" [value]="true"
                                                [(ngModel)]="personalDetailsFormObject.hasNigerianPassport"
                                                class="infoyn" id="convictionsYes" />
                                            <label for="convictionsYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="personalDetailsFormObject.submitted && nigerianPassport.invalid">
                                            <span *ngIf="nigerianPassport.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="personalDetailsFormObject.hasNigerianPassport">
                                            <label class="fieldlabels">Nigerian Passport Number:<span
                                                    class="medatory">*</span></label>
                                            <input type="text"
                                                [(ngModel)]="personalDetailsFormObject.nigerianPassportNumber"
                                                name="nigerianPassportNumber" class="form-control" required
                                                #nigerianPassportNumber="ngModel" minlength="5" maxlength="15"
                                                (input)="personalDetailsFormObject.nigerianPassportNumber = personalDetailsFormObject.nigerianPassportNumber.toUpperCase()">

                                            <span class="alert-danger"
                                                *ngIf="personalDetailsForm.submitted && nigerianPassportNumber.invalid">
                                                <span *ngIf="personalDetailsFormObject.errors?.required">Country is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="grid-onethird-box">

                            <div class="instruction_box">

                                <h4>Instructions</h4>

                                <ng-template [ngTemplateOutlet]="instructions"></ng-template>

                            </div>

                        </div>





                        <!-- dependent-form.component.html -->

                        <div class="dependents-container" *ngIf="canAcceptDependant || dependents?.length > 0">
                            <div *ngFor="let dependent of dependents; let i = index" class="dependent-form bg-danger">
                                <h3>Dependent #{{i + 1}}</h3>
                                <button type="button" class="btn btn-danger remove-btn"
                                    (click)="removeDependent(dependent.id)" [disabled]="dependents.length <= 1">
                                    Remove
                                </button>

                                <div class="grid-two reverse_col">
                                    <div class="grid-two">
                                        <!-- Title Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">1. Title <span class="medatory">*</span></label>
                                            <div class="input_box">
                                                <select name="title_{{dependent.id}}" [(ngModel)]="dependent.title"
                                                    #title="ngModel" class="effect" required
                                                    (ngModelChange)="setGender(dependent)">
                                                    <option [value]="constants.BLANK">
                                                        {{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                                    </option>
                                                    <option [value]="constants.MR">Mr.</option>
                                                    <option [value]="constants.MISS">Miss</option>
                                                    <option [value]="constants.MS">Ms.</option>
                                                    <option [value]="constants.OTHER">Other</option>
                                                </select>
                                                <span class="icon_caret"><i class="fa fa-caret-down"
                                                        aria-hidden="true"></i></span>
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger" *ngIf="dependent.formSubmitted && title.invalid">
                                                <span *ngIf="title.errors?.required">Title is required!</span>
                                            </span>
                                        </div>

                                        <!-- Surname Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">2. Surname <span
                                                    class="medatory">*</span></label>
                                            <div class="input_box">
                                                <input type="text" name="lastName_{{dependent.id}}"
                                                    [(ngModel)]="dependent.lastName" #lastName="ngModel" class="effect"
                                                    required minlength="2" maxlength="50"
                                                    [pattern]="pattern.COMMON_FIELD_PATTERN"
                                                    (blur)="utils.validateName(lastName, 'Surname', dependent.lastName)">
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger"
                                                *ngIf="dependent.formSubmitted && lastName.invalid">
                                                <span *ngIf="lastName.errors?.required">Surname is required!</span>
                                                <span *ngIf="lastName.errors?.minlength">Surname should be of minimum 2
                                                    characters!</span>
                                                <span *ngIf="!lastName.errors?.minlength && lastName.errors?.pattern">
                                                    Surname should start and end with an alphabet!
                                                </span>
                                                <span
                                                    *ngIf="lastName.errors?.hasError">{{lastName.errors.errorMessage}}</span>
                                            </span>
                                        </div>

                                        <!-- First Name Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">3. First Name <span
                                                    class="medatory">*</span></label>
                                            <div class="input_box">
                                                <input type="text" name="firstName_{{dependent.id}}"
                                                    [(ngModel)]="dependent.firstName" #firstName="ngModel"
                                                    class="effect" required="required" minlength="2" maxlength="50"
                                                    [pattern]="pattern.FIRST_NAME_FIELD_PATTERN"
                                                    (ngInit)="utils.validateName(firstName, 'First name', dependent.firstName);"
                                                    (blur)="utils.validateName(firstName, 'First name', dependent.firstName);">
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger"
                                                *ngIf="dependent.formSubmitted && firstName.invalid">
                                                <span *ngIf="firstName.errors?.required">First Name is required!</span>
                                                <span *ngIf="firstName.errors?.minlength">First Name should be of
                                                    minimum 2
                                                    characters!</span>
                                                <span *ngIf="!firstName.errors?.minlength && firstName.errors?.pattern">
                                                    First Name should start with alphabet and end with an alphabet or
                                                    number!
                                                </span>
                                                <span
                                                    *ngIf="firstName.errors?.hasError">{{firstName.errors.errorMessage}}</span>
                                            </span>
                                        </div>

                                        <!-- Middle Name Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">4. Middle Name</label>
                                            <div class="input_box">
                                                <input type="text" name="middleName_{{dependent.id}}"
                                                    [(ngModel)]="dependent.middleName" #middleName="ngModel"
                                                    class="effect" minlength="2" maxlength="50"
                                                    [pattern]="pattern.COMMON_FIELD_PATTERN"
                                                    (ngInit)="utils.validateName(middleName, 'Middle name', dependent.middleName);"
                                                    (blur)="utils.validateName(middleName, 'Middle name', dependent.middleName);">
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger"
                                                *ngIf="dependent.formSubmitted && middleName.invalid">
                                                <span *ngIf="middleName.errors?.minlength">Middle Name should be of
                                                    minimum
                                                    2
                                                    characters!</span>
                                                <span
                                                    *ngIf="!middleName.errors?.minlength && middleName.errors?.pattern">
                                                    Middle Name should start and end with an alphabet!
                                                </span>
                                                <span
                                                    *ngIf="middleName.errors?.hasError">{{middleName.errors.errorMessage}}</span>
                                            </span>
                                        </div>

                                        <!-- Date of Birth Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">
                                                5. Date of Birth <span class="small_screen">(dd/mm/yyyy)</span> <span
                                                    class="medatory">*</span>
                                            </label>

                                            <div class="grid-date">
                                                <div class="input_box">
                                                    <input type="text" name="dateOfBirthDay_{{ dependent.id }}"
                                                        [(ngModel)]="dependent.dateOfBirthDay" #dateOfBirthDay="ngModel"
                                                        class="effect" required maxlength="2" placeholder="DD"
                                                        numberOnly (blur)="validateDependentAge(dependent)" />
                                                    <span class="focus-border"><i></i></span>
                                                </div>

                                                <div class="input_box">
                                                    <select name="dateOfBirthMonth_{{ dependent.id }}"
                                                        [(ngModel)]="dependent.dateOfBirthMonth"
                                                        #dateOfBirthMonth="ngModel" class="effect" required
                                                        (change)="validateDependentAge(dependent)">
                                                        <option *ngFor="let month of monthsList" [value]="month.value">
                                                            {{
                                                            month.text }}</option>
                                                    </select>
                                                    <span class="icon_caret"><i class="fa fa-caret-down"
                                                            aria-hidden="true"></i></span>
                                                    <span class="focus-border"><i></i></span>
                                                </div>

                                                <div class="input_box">
                                                    <input type="text" name="dateOfBirthYear_{{ dependent.id }}"
                                                        [(ngModel)]="dependent.dateOfBirthYear"
                                                        #dateOfBirthYear="ngModel" class="effect" required minlength="4"
                                                        maxlength="4" placeholder="YYYY" numberOnly
                                                        (blur)="validateDependentAge(dependent)" />
                                                    <span class="focus-border"><i></i></span>
                                                </div>
                                            </div>

                                            <!-- Validation Messages -->
                                            <span class="alert-danger" *ngIf="
                                                dependent.formSubmitted &&
                                                (dateOfBirthDay.invalid ||
                                                  dateOfBirthMonth.invalid ||
                                                  dateOfBirthYear.invalid ||
                                                  dependent.ageError)
                                              ">
                                                <span *ngIf="
                                                  dateOfBirthDay.errors?.required ||
                                                  dateOfBirthMonth.errors?.required ||
                                                  dateOfBirthYear.errors?.required
                                                ">
                                                    Date of Birth is required!
                                                </span>

                                                <span *ngIf="dateOfBirthYear.errors?.minlength">
                                                    Date of Birth's year should be 4 digits!
                                                </span>

                                                <span *ngIf="
                                                  showAgeError(dependent) &&
                                                  !dateOfBirthDay.invalid &&
                                                  !dateOfBirthMonth.invalid &&
                                                  !dateOfBirthYear.invalid
                                                ">
                                                    Dependent must be under 18 years old!
                                                </span>
                                            </span>
                                        </div>

                                        <!-- Place of Birth Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">6. Place of Birth <span
                                                    class="medatory">*</span></label>
                                            <div class="input_box">
                                                <input type="text" name="placeOfBirth_{{dependent.id}}"
                                                    [(ngModel)]="dependent.placeOfBirth" #placeOfBirth="ngModel"
                                                    class="effect" required minlength="2" maxlength="20"
                                                    [pattern]="pattern.COMMON_FIELD_PATTERN">
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger"
                                                *ngIf="dependent.formSubmitted && placeOfBirth.invalid">
                                                <span *ngIf="placeOfBirth.errors?.required">Place of Birth is
                                                    required!</span>
                                                <span *ngIf="placeOfBirth.errors?.minlength">Place of Birth should be of
                                                    minimum
                                                    2 characters!</span>
                                                <span
                                                    *ngIf="!placeOfBirth.errors?.minlength && placeOfBirth.errors?.pattern">
                                                    Place of Birth should start and end with an alphabet!
                                                </span>
                                            </span>
                                        </div>




                                    </div>
                                    <!-- Image Upload -->
                                    <div class="img_upload">
                                        <div class="img_box">
                                            <input type="hidden" name="passportImageData_{{dependent.id}}"
                                                [(ngModel)]="dependent.passportImageData" #passportImageData="ngModel"
                                                class="effect" required>
                                            <img [src]="dependent.passportImageData || 'assets/images/defaultImage.png'"
                                                class="cropped">
                                            <span
                                                (click)="openFileUploadModal(dependent, 'passportImageData', 'passportImageFileType', true)"
                                                class="icon_image">
                                                <i class="fa fa-camera" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                        <span class="alert alert-danger" role="alert"
                                            *ngIf="dependent.formSubmitted && passportImageData.invalid"
                                            style="text-align: center;">
                                            <span *ngIf="passportImageData.errors?.required">Image is required!</span>
                                        </span>
                                    </div>

                                </div>



                                <div>
                                    <div class="grid-two reverse_col">
                                        <!-- Gender Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">7. Gender <span class="medatory">*</span></label>
                                            <div class="input_box">
                                                <select name="gender_{{dependent.id}}" [(ngModel)]="dependent.gender"
                                                    #gender="ngModel" class="effect" required>
                                                    <option [value]="constants.BLANK">
                                                        {{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                                    </option>
                                                    <option [value]="constants.MALE">Male</option>
                                                    <option [value]="constants.FEMALE">Female</option>
                                                </select>
                                                <span class="icon_caret"><i class="fa fa-caret-down"
                                                        aria-hidden="true"></i></span>
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger"
                                                *ngIf="dependent.formSubmitted && gender.invalid">
                                                <span *ngIf="gender.errors?.required">Gender is required!</span>
                                            </span>
                                        </div>

                                        <!-- Passport Number Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">9. Passport Number <span
                                                    class="medatory">*</span></label>
                                            <div class="input_box">
                                                <input type="text" name="passportNumber_{{dependent.id}}"
                                                    [(ngModel)]="dependent.passportNumber" #passportNumber="ngModel"
                                                    class="effect" required minlength="5" maxlength="50" alphaNumeric
                                                    [identifyValueChange]="dependent"
                                                    (input)="dependent.passportNumber = dependent.passportNumber?.toUpperCase()">
                                                <span class="tooltip"><span class='tooltipArrow'></span>Enter your
                                                    passport
                                                    number as it appears on your passport. The passport number may
                                                    contain
                                                    numbers and/or characters. Please closely distinguish between the
                                                    number
                                                    zero and the letter O. The passport number is required to complete
                                                    the
                                                    application or to check the status of your application.</span>
                                                <span class="focus-border "><i></i></span>
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger"
                                                *ngIf="dependent.formSubmitted && passportNumber.invalid">
                                                <span *ngIf="passportNumber.errors?.required">Passport Number is
                                                    required!</span>
                                                <span *ngIf="passportNumber.errors?.minlength">Passport Number should be
                                                    of
                                                    minimum 5 digits!</span>
                                            </span>
                                        </div>

                                        <!-- Passport Expiry Date Field -->
                                        <div class="form_box">
                                            <label class="fieldlabels">10. Passport Expiry Date(dd/mm/yyyy) <span
                                                    class="medatory">*</span></label>
                                            <div class="input_box">
                                                <input type="text" name="passportExpiryDate_{{dependent.id}}"
                                                    mwlFlatpickr [minDate]="passportMinExpiryDate"
                                                    [(ngModel)]="dependent.passportExpiryDate"
                                                    #passportExpiryDate="ngModel" class="effect" required
                                                    (blur)="utils.validateCalendarYear(passportExpiryDate, dependent.passportExpiryDate);">
                                                <span class="focus-border"><i></i></span>
                                            </div>
                                            <span class="alert-danger"
                                                *ngIf="dependent.formSubmitted && passportExpiryDate.invalid">
                                                <span *ngIf="passportExpiryDate.errors?.required">Passport Expiry Date
                                                    is
                                                    required!</span>
                                                <span
                                                    *ngIf="passportExpiryDate.errors?.hasError">{{passportExpiryDate.errors.errorMessage}}</span>
                                            </span>
                                        </div>

                                        <!-- Nationality -->
                                        <div class="form_box" *ngIf="generalDetailsFormObject.visaClass === 'F9B'">
                                            <label class="fieldlabels"> Nationality<span
                                                    class="medatory">*</span></label>
                                            <div class="input_box">
                                                <mat-select name="nationality" [(ngModel)]="dependent.nationality"
                                                    #nationality="ngModel" class="effect" required="required">
                                                    <mat-option>
                                                        <ngx-mat-select-search
                                                            [formControl]="nationalitySelectService.selectFilterControl"
                                                            noEntriesFoundLabel="No data found"
                                                            placeholderLabel="Search"></ngx-mat-select-search>
                                                    </mat-option>
                                                    <mat-option
                                                        *ngFor="let nationality of nationalitySelectService.filteredOptions | async"
                                                        [value]="nationality.value">{{nationality.text}}</mat-option>
                                                </mat-select>
                                                <span class="tooltip"><span class='tooltipArrow'></span>Choose the
                                                    country of
                                                    citizenship, as it appears on your passport. The country of
                                                    citizenship is
                                                    required to complete the application.</span>
                                                <span class="focus-border "><i></i></span>
                                            </div>
                                            <span class="alert-danger" *ngIf="nationality.invalid">
                                                <span *ngIf="nationality.errors.required">
                                                    Nationality is required!
                                                </span>
                                            </span>
                                        </div>

                                        <!-- Nigerian Passport Field -->
                                        <div class="form_box-1 mb30">
                                            <div class="radio">
                                                <label class="fieldlabels"> Do you have a Nigerian Passport?<span
                                                        class="medatory">*</span></label>
                                                <div class="radio-group">
                                                    <input type="radio" name="nigerianPassport_{{dependent.id}}"
                                                        [value]="false" [(ngModel)]="dependent.hasNigerianPassport"
                                                        class="infoyn" id="nigerianPassportNo_{{dependent.id}}" required
                                                        #nigerianPassport="ngModel" />
                                                    <label for="nigerianPassportNo_{{dependent.id}}"
                                                        class="infoyn">No</label>
                                                </div>
                                                <div class="radio-group">
                                                    <input type="radio" name="nigerianPassport_{{dependent.id}}"
                                                        [value]="true" [(ngModel)]="dependent.hasNigerianPassport"
                                                        class="infoyn" id="nigerianPassportYes_{{dependent.id}}" />
                                                    <label for="nigerianPassportYes_{{dependent.id}}"
                                                        class="infoyn">Yes</label>
                                                </div>
                                                <span class="alert-danger"
                                                    *ngIf="dependent.formSubmitted && nigerianPassport.invalid">
                                                    <span *ngIf="nigerianPassport.errors?.required">This field is
                                                        required!</span>
                                                </span>

                                                <div *ngIf="dependent.hasNigerianPassport">
                                                    <label class="fieldlabels">Nigerian Passport Number:<span
                                                            class="medatory">*</span></label>
                                                    <input type="text" [(ngModel)]="dependent.nigerianPassportNumber"
                                                        name="nigerianPassportNumber_{{dependent.id}}"
                                                        class="form-control" required #nigerianPassportNumber="ngModel"
                                                        minlength="5" maxlength="15"
                                                        (input)="dependent.nigerianPassportNumber = dependent.nigerianPassportNumber?.toUpperCase()">
                                                    <span class="alert-danger"
                                                        *ngIf="dependent.formSubmitted && nigerianPassportNumber.invalid">
                                                        <span *ngIf="nigerianPassportNumber.errors?.required">Nigerian
                                                            Passport
                                                            Number is required!</span>
                                                        <span *ngIf="nigerianPassportNumber.errors?.minlength">Should be
                                                            minimum
                                                            5 characters!</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>





                            </div>
                        </div>

                    </div>





                    <div class="action-buttons" *ngIf="canAcceptDependant || dependents?.length > 0">
                        <button type="button" (click)="addDependent()" class="btn btn-success"
                            [disabled]="dependents?.length >= this.constants.MAX_DEPENDENTS">
                            <i class="fa fa-plus"></i> Add Dependent
                            <span *ngIf="dependents?.length >= this.constants.MAX_DEPENDENTS" class="max-reached">
                                (Maximum {{this.constants?.MAX_DEPENDENTS}} reached)
                            </span>
                        </button>

                        <button type="button" (click)="clearAllDependents()" class="btn btn-danger"
                            [disabled]="dependents?.length === 0" *ngIf="dependents?.length > 0">
                            <i class="fa fa-trash"></i> Clear All
                        </button>
                    </div>

                    <input type="button" (click)="openPreviousFieldSet();" class="action-button-previous back_btn mt20"
                        value="Previous Page" />
                    <input type="submit" (click)="setShallExitApplication(true);" class="save_btn"
                        value="Save & Exit" />

                    <input type="submit" (click)="setShallExitApplication(false);" class="action-button custom_btn"
                        value="Continue" />






                </form>
            </fieldset>

            <fieldset *ngIf="applicationStage === constants.TRAVEL_INFO_STEP">

                <div class="step_info">
                    <span>Step 3: {{applicationStepsList[2].label}}</span>
                </div>

                <form #travelDetailsForm="ngForm"
                    (ngSubmit)="travelDetailsForm.form.valid && openContactDetailsForm($event)" name="travelDetailsForm"
                    autocomplete="off" id="msform" errorFocus>

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="travelDetailsFormObject.hasFieldValueChanged" #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="travelDetailsFormObject.callableFunctionName" #callableFunctionName="ngModel">

                    <ng-template #instructions>

                        <ul>

                            <li>The information you provide must match the information on your passport. Any
                                discrepancies will cancel your visa application.</li>

                            <li>You should note down the application and reference numbers of your application. This
                                will help in any future communication in respect of your application. You can also take
                                a printout of your completed/paid application for this purpose.</li>

                            <li>There must be a 3-day interval between your application submission date and the date you
                                intend to arrive in Nigeria.</li>

                        </ul>

                    </ng-template>

                    <div class="grid-one-third">

                        <div class="grid-onethird-box">

                            <details>

                                <summary>Instructions for Applicant</summary>

                                <div class="content">

                                    <ng-template [ngTemplateOutlet]="instructions"></ng-template>

                                </div>

                            </details>

                            <div class="grid-two">

                                <div class="form_box">
                                    <label class="fieldlabels">1. Purpose of Journey<span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="journeyPurpose" hint
                                            [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.journeyPurpose"
                                            #journeyPurpose="ngModel" class="effect" required="required"
                                            maxlength="150">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Enter the Purpose of
                                            Journey.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && journeyPurpose.invalid">
                                        <span *ngIf="journeyPurpose.errors?.required">
                                            Purpose of Journey is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">2. Travel Carrier (Airline, Shipping and Bus
                                        company)<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="airlineName" hint
                                            [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.airlineName" #airlineName="ngModel"
                                            class="effect" required="required" maxlength="50">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write airline
                                            name.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && airlineName.invalid">
                                        <span *ngIf="airlineName.errors?.required">
                                            Airline is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">3. Flight/Bus/Vessel Number<span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="flightNumber" hint
                                            [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.flightNumber" #flightNumber="ngModel"
                                            class="effect" required="required" maxlength="10">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write flight
                                            number.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && flightNumber.invalid">
                                        <span *ngIf="flightNumber.errors?.required">
                                            Flight Number is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">4. Country of Departure<span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <mat-select name="departureCountry"
                                            [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.departureCountry"
                                            #departureCountry="ngModel" class="effect" required="required"
                                            (openedChange)="utils.checkHasMatValueChanged($event, travelDetailsFormObject, 'departureCountry');">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="countrySelectService.selectFilterControl"
                                                    noEntriesFoundLabel="No data found"
                                                    placeholderLabel="Search"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option
                                                *ngFor="let country of countrySelectService.filteredOptions | async"
                                                [value]="country.value">{{country.text}}</mat-option>
                                        </mat-select>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please choose country
                                            that you are departured.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && departureCountry.invalid">
                                        <span *ngIf="departureCountry.errors?.required">
                                            Country of Departure is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">5. Date of Departure(dd/mm/yyyy)<span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="expectedDepartureDate"
                                            [identifyValueChange]="travelDetailsFormObject" mwlFlatpickr
                                            [minDate]="minDepartureDate"
                                            [(ngModel)]="travelDetailsFormObject.expectedDepartureDate"
                                            #expectedDepartureDate="ngModel" class="effect" required="required"
                                            maxlength="10" (ngModelChange)="setMinArrivalDate();"
                                            (blur)="utils.validateCalendarYear(expectedDepartureDate, travelDetailsFormObject.expectedDepartureDate);">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Expected date of
                                            departure.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && expectedDepartureDate.invalid">
                                        <span *ngIf="expectedDepartureDate.errors?.required">
                                            Date of Departure is required!
                                        </span>
                                        <span *ngIf="expectedDepartureDate.errors.hasError">
                                            {{expectedDepartureDate.errors.errorMessage}}
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">6. Date of Arrival(dd/mm/yyyy)<span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="expectedArrivalDate"
                                            [identifyValueChange]="travelDetailsFormObject" mwlFlatpickr
                                            [minDate]="minArrivalDate"
                                            [(ngModel)]="travelDetailsFormObject.expectedArrivalDate"
                                            #expectedArrivalDate="ngModel" class="effect" required="required"
                                            maxlength="10"
                                            (blur)="utils.validateCalendarYear(expectedArrivalDate, travelDetailsFormObject.expectedArrivalDate);">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Expected date of
                                            arrival.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && expectedArrivalDate.invalid">
                                        <span *ngIf="expectedArrivalDate.errors?.required">
                                            Date of Arrival is required!
                                        </span>
                                        <span *ngIf="expectedArrivalDate.errors.hasError">
                                            {{expectedArrivalDate.errors.errorMessage}}
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">7. Arrival Channel<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <select name="arrivalChannel" [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.arrivalChannel"
                                            #arrivalChannel="ngModel" class="effect" required="required">
                                            <option [value]="constants.BLANK">{{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                            </option>
                                            <option [value]="constants.AIR">Air</option>
                                            <option [value]="constants.LAND">Land</option>
                                            <option [value]="constants.SEA">Sea</option>
                                        </select>
                                        <span class="icon_caret"><i class="fa fa-caret-down"
                                                aria-hidden="true"></i></span>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please choose arrival
                                            channel.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && arrivalChannel.invalid">
                                        Arrival channel is required!
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">8. Duration of Stay(In Days)<span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="durationOfStay"
                                            [identifyValueChange]="travelDetailsFormObject" numberOnly
                                            [(ngModel)]="travelDetailsFormObject.durationOfStay"
                                            #durationOfStay="ngModel" class="effect" required="required" maxlength="4">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Expected duration of
                                            stays.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="travelDetailsForm.submitted && durationOfStay.invalid">
                                        <span *ngIf="durationOfStay.errors?.required">
                                            Duration of Stay is required!
                                        </span>
                                    </span>
                                </div>


                                <div class="form_box" *ngIf="travelDetailsFormObject.arrivalChannel ==  'Air' ">
                                    <label class="fieldlabels">9. Port of Entry<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <select name="entryPort" [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.entryPort" #entryPort="ngModel"
                                            class="effect" required="required">
                                            <option [value]="constants.BLANK">{{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                            </option>
                                            <option [value]="constants.ABUJA">Nnamdi Azikiwe international Airport,
                                                Abuja</option>
                                            <option [value]="constants.KANO">Mallam Aminu Kano Airport, Kano
                                            </option>
                                            <option [value]="constants.LAGOS">Murtala Mohammed Airport, Lagos
                                            </option>
                                            <option [value]="constants.CALABAR">Margret Ekpo Airport, Calabar
                                            </option>
                                            <option [value]="constants.RIVERS">PortHarcourt International Airport,
                                                Rivers</option>
                                            <option [value]="constants.ENUGU">Akanu Ibiam International Airport,
                                                Enugu
                                            </option>
                                        </select>
                                        <span class="icon_caret"><i class="fa fa-caret-down"
                                                aria-hidden="true"></i></span>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please choose port of
                                            entry.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger" *ngIf="travelDetailsForm.submitted && entryPort.invalid">
                                        Port of Entry is required!
                                    </span>
                                </div>

                                <div class="form_box" *ngIf="travelDetailsFormObject.arrivalChannel ==  'Sea' ">
                                    <label class="fieldlabels">9. Port of Entry<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <select name="entryPort" [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.entryPort" #entryPort="ngModel"
                                            class="effect" required="required">
                                            <option [value]="constants.BLANK">{{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                            </option>
                                            <option [value]="constants.ABUJA">Apapa (Lagos Port Complex)</option>
                                            <option [value]="constants.KANO">Tin Can Island Port</option>
                                            <option [value]="constants.LAGOS">Onne Port
                                            </option>
                                            <option [value]="constants.CALABAR">(Old) Port Harcourt
                                            </option>
                                            <option [value]="constants.RIVERS">Warri Port</option>
                                            <option [value]="constants.ENUGU">Calabar Port</option>
                                            <option [value]="constants.LAGOS">Lekki Deep Sea Port</option>
                                        </select>
                                        <span class="icon_caret"><i class="fa fa-caret-down"
                                                aria-hidden="true"></i></span>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please choose port of
                                            entry.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger" *ngIf="travelDetailsForm.submitted && entryPort.invalid">
                                        Port of Entry is required!
                                    </span>
                                </div>

                                <div class="form_box" *ngIf="travelDetailsFormObject.arrivalChannel ==  'Land' ">
                                    <label class="fieldlabels">9. Port of Entry<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <select name="entryPort" [identifyValueChange]="travelDetailsFormObject"
                                            [(ngModel)]="travelDetailsFormObject.entryPort" #entryPort="ngModel"
                                            class="effect" required="required">
                                            <option [value]="constants.BLANK">{{constants.DEFAULT_SELECT_OPTION_LABEL}}
                                            </option>
                                            <option [value]="constants.ABUJA">Seme-Krake (Lagos)</option>
                                            <option [value]="constants.KANO">Idiroko (Ogun)</option>
                                            <option [value]="constants.LAGOS">Illela (Sokoto)</option>
                                            <option [value]="constants.CALABAR">Maigatari (Jigawa)</option>
                                            <option [value]="constants.RIVERS">Jibiya (Katsina)</option>
                                            <option [value]="constants.ENUGU">Kamba (Kebbi)</option>
                                            <option [value]="constants.ENUGU">Mfum (Etung, Cross River)</option>
                                            <option [value]="constants.ENUGU">Ikom (Cross River)</option>
                                        </select>
                                        <span class="icon_caret"><i class="fa fa-caret-down"
                                                aria-hidden="true"></i></span>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please choose port of
                                            entry.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger" *ngIf="travelDetailsForm.submitted && entryPort.invalid">
                                        Port of Entry is required!
                                    </span>
                                </div>


                            </div>

                            <input type="button" (click)="openPreviousFieldSet()"
                                class="action-button-previous back_btn mt20" value="Previous Page" />
                            <input type="submit" (click)="setShallExitApplication(true)" class="save_btn"
                                value="Save & Exit" />
                            <input type="submit" (click)="setShallExitApplication(false)"
                                class="action-button custom_btn" value="Continue" />

                        </div>

                        <div class="grid-onethird-box">

                            <div class="instruction_box mb20">

                                <h4>Instructions</h4>

                                <ng-template [ngTemplateOutlet]="instructions"></ng-template>

                            </div>

                        </div>

                    </div>

                </form>

            </fieldset>

            <fieldset *ngIf="applicationStage === constants.CONTACT_INFO_STEP">

                <div class="step_info">
                    <span>Step 4: {{applicationStepsList[3].label}}</span>
                </div>

                <form #contactDetailsForm="ngForm"
                    (ngSubmit)="contactDetailsForm.form.valid && openSupportingDocumentsForm($event)"
                    name="contactDetailsForm" autocomplete="off" id="msform" errorFocus>

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="contactDetailsFormObject.hasFieldValueChanged" #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="contactDetailsFormObject.callableFunctionName" #callableFunctionName="ngModel">

                    <ng-template #instructions>

                        <ul>

                            <li>The information you provide must match the information on your passport. Any
                                discrepancies will cancel your visa application.</li>

                            <li>Applicants are requested to verify their application details before making payment.</li>

                            <li>Applicants have an option to save their application if they choose not to pay online.
                            </li>

                            <li>Letters(A-Z, a-z), Numbers (0-9), period(.) hyphen or dash(-), apostrophe (') and space
                                are the allowable characters for names.</li>

                        </ul>

                    </ng-template>

                    <div class="grid-one-third">

                        <div class="grid-onethird-box">

                            <details>

                                <summary>Instructions for Applicant </summary>

                                <div class="content">

                                    <ng-template [ngTemplateOutlet]="instructions"></ng-template>

                                </div>

                            </details>

                            <div class="grid-two">

                                <div class="form_box ">
                                    <label class="fieldlabels">1. Contact Name/ Hotel Name<span
                                            class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="contactName" hint
                                            [identifyValueChange]="contactDetailsFormObject"
                                            [(ngModel)]="contactDetailsFormObject.contactName" #contactName="ngModel"
                                            class="effect" required="required" maxlength="50"
                                            (ngInit)="utils.validateName(contactName, 'Contact Name/ Hotel Name', contactDetailsFormObject.contactName);"
                                            (blur)="utils.validateName(contactName, 'Contact Name/ Hotel Name', contactDetailsFormObject.contactName);">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write the name of
                                            hotel name and contact person name.</span>
                                        <span class="focus-border "><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="contactDetailsForm.submitted && contactName.invalid">
                                        <span *ngIf="contactName.errors?.required">
                                            Contact Name/ Hotel Name is required!
                                        </span>
                                        <span *ngIf="contactName.errors.hasError">
                                            {{contactName.errors.errorMessage}}
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">2. Contact Number<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="contactPhone" hint numberOnly
                                            [identifyValueChange]="contactDetailsFormObject"
                                            [(ngModel)]="contactDetailsFormObject.contactPhone" #contactPhone="ngModel"
                                            class="focus_border" required="required" minlength="5" maxlength="16"
                                            ng2TelInput [ng2TelInputOptions]="contactPhoneNumberOptions"
                                            (countryChange)="utils.setMobileNumberFields($event, contactDetailsFormObject, ['countryISO', 'dialCode'])"
                                            (intlTelInputObject)="utils.setMobileNumberFields($event.s, contactDetailsFormObject, ['countryISO', 'dialCode'])">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write the contact
                                            number.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="contactDetailsForm.submitted && contactPhone.invalid">
                                        <span *ngIf="contactPhone.errors?.required">
                                            Contact Number is required!
                                        </span>
                                        <span *ngIf="contactPhone.errors?.minlength">
                                            Contact Number should be of minimum 5 digits!
                                        </span>
                                    </span>
                                </div>



                                <div class="form_box h_txt">
                                    <label class="fieldlabels">3. Address <span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="contactAddress" hint
                                            [identifyValueChange]="contactDetailsFormObject"
                                            [(ngModel)]="contactDetailsFormObject.contactAddress"
                                            #contactAddress="ngModel" class="effect" required="required" minlength="10"
                                            maxlength="70">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write the
                                            address at which you can be contacted. This address is required to
                                            complete the application.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="contactDetailsForm.submitted && contactAddress.invalid">
                                        <span *ngIf="contactAddress.errors?.required">
                                            Address is required!
                                        </span>
                                        <span *ngIf="contactAddress.errors?.minlength">
                                            Address should be of minimum 10 characters!
                                        </span>
                                    </span>
                                </div>





                                <div class="form_box">
                                    <label class="fieldlabels">4. City / Town<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="contactCity" hint
                                            [identifyValueChange]="contactDetailsFormObject"
                                            [(ngModel)]="contactDetailsFormObject.contactCity" #contactCity="ngModel"
                                            class="effect" required="required" maxlength="50">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write the
                                            name of your city/town.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="contactDetailsForm.submitted && contactCity.invalid">
                                        <span *ngIf="contactCity.errors?.required">
                                            City / Town is required!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">5. State<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <mat-select name="contactState" [identifyValueChange]="contactDetailsFormObject"
                                            [(ngModel)]="contactDetailsFormObject.contactState" #contactState="ngModel"
                                            class="effect" required="required"
                                            (openedChange)="utils.checkHasMatValueChanged($event, contactDetailsFormObject, 'contactState');">
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [formControl]="stateSelectService.selectFilterControl"
                                                    noEntriesFoundLabel="No data found"
                                                    placeholderLabel="Search"></ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let state of stateSelectService.filteredOptions | async"
                                                [value]="state.value">{{state.text}}</mat-option>
                                        </mat-select>
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please choose state
                                            that you are departured.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="contactDetailsForm.submitted && contactState.invalid">
                                        <span *ngIf="contactState.errors?.required">
                                            State is required!
                                        </span>
                                    </span>
                                </div>



                                <div class="form_box">
                                    <label class="fieldlabels">6. Contact E-mail<span class="medatory">*</span></label>
                                    <div class="input_box">
                                        <input type="text" name="contactEmail" hint
                                            [identifyValueChange]="contactDetailsFormObject"
                                            [(ngModel)]="contactDetailsFormObject.contactEmail" #contactEmail="ngModel"
                                            class="effect" required="required" maxlength="50"
                                            [pattern]="pattern.EMAIL_FIELD_PATTERN">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write the e-mail
                                            ID.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="contactDetailsForm.submitted && contactEmail.invalid">
                                        <span *ngIf="contactEmail.errors?.required">
                                            Contact E-mail is required!
                                        </span>
                                        <span *ngIf="contactEmail.errors?.pattern">
                                            Contact E-mail should be valid!
                                        </span>
                                    </span>
                                </div>

                                <div class="form_box">
                                    <label class="fieldlabels">7. Postal Code</label>
                                    <div class="input_box">
                                        <input type="text" name="contactPostalCode" hint numberOnly
                                            [identifyValueChange]="contactPostalCode"
                                            [(ngModel)]="contactDetailsFormObject.contactPostalCode"
                                            #contactPostalCode="ngModel" class="effect" maxlength="6">
                                        <span class="tooltip"><span class='tooltipArrow'></span>Please write the postal
                                            code at which you can be contacted. This address is required to complete the
                                            application.</span>
                                        <span class="focus-border"><i></i></span>
                                    </div>
                                    <span class="alert-danger"
                                        *ngIf="contactDetailsForm.submitted && contactPostalCode.invalid">
                                        <span *ngIf="contactPostalCode.errors?.required">
                                            Postal Code is required!
                                        </span>
                                    </span>
                                </div>

                            </div>

                        </div>

                        <div class="grid-onethird-box">

                            <div class="instruction_box">

                                <h4>Instructions</h4>

                                <ng-template [ngTemplateOutlet]="instructions"></ng-template>

                            </div>

                        </div>

                    </div>

                    <input type="button" (click)="openPreviousFieldSet()" class="action-button-previous back_btn mt20"
                        value="Previous Page" />
                    <input type="submit" (click)="setShallExitApplication(true)" class="save_btn" value="Save & Exit" />
                    <input type="submit" (click)="setShallExitApplication(false)" class="action-button custom_btn"
                        value="Continue" />

                </form>

            </fieldset>

            <fieldset *ngIf="applicationStage === constants.SUPPORTING_DOCUMENTS_STEP">

                <div class="step_info">
                    <span>Step 5: {{applicationStepsList[4].label}}</span>
                </div>

                <form #supportingDocumentsForm="ngForm" (ngSubmit)="handleFormSubmit(supportingDocumentsForm, $event)"
                    name="supportingDocumentsForm" autocomplete="off" id="msform" errorFocus>

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="supportingDocumentsFormObject.hasFieldValueChanged"
                        #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="supportingDocumentsFormObject.callableFunctionName"
                        #callableFunctionName="ngModel">

                    <ng-template #instructions>
                        <ul>
                            <li>The information you provide must match the information on your passport.</li>
                            <li>Applicants are requested to verify their application details before making payment.</li>
                            <li>Applicants have an option to save their application if they choose not to pay online.
                            </li>
                        </ul>
                    </ng-template>

                    <div class="grid-one-third">
                        <div class="grid-onethird-box">
                            <details>
                                <summary>Instructions for Applicant</summary>
                                <div class="content">
                                    <ng-template [ngTemplateOutlet]="instructions"></ng-template>
                                </div>
                            </details>

                            <div class="grid-third">
                                <div class="grid-third-box"
                                    *ngFor="let requiredDocument of supportingDocumentsList; trackBy: trackByF; let i = index">
                                    <div class="upload_docs">
                                        <label class="fieldlabels label_doc">
                                            {{requiredDocument.documentLabel}}
                                            <span *ngIf="requiredDocument.required === constants.TRUE"
                                                class="medatory">*</span>
                                        </label>

                                        <div class="input_box">
                                            <input type="hidden" [name]="'fileBase64Data'+requiredDocument.id"
                                                [required]="requiredDocument.required === constants.TRUE"
                                                [(ngModel)]="supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id]"
                                                #fileBase64Data="ngModel">

                                            <div class="file_uploads">
                                                <div class="upload_box">
                                                    <div *ngIf="!supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id]"
                                                        class="upload_icon">
                                                        <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                                    </div>
                                                    <span
                                                        *ngIf="!supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id]">
                                                        Files with Extension jpg, png, jpeg or pdf are allowed
                                                        only.
                                                    </span>

                                                    <img *ngIf="supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id] && 
                                                   supportingDocumentsFormObject['fileType'+requiredDocument.id] !== constants.FILE_TYPE_PDF"
                                                        [src]="supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id]">

                                                    <span
                                                        *ngIf="supportingDocumentsFormObject['fileType'+requiredDocument.id] === constants.FILE_TYPE_PDF">
                                                        <img src="assets/images/pdf.svg">
                                                    </span>
                                                </div>

                                                <div class="action-buttons">
                                                    <input
                                                        *ngIf="!supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id]"
                                                        type="button"
                                                        (click)="openFileUploadModal(supportingDocumentsFormObject, 'fileBase64Data'+requiredDocument.id, 'fileType'+requiredDocument.id, false)"
                                                        class="upload_btn" value="Upload file">

                                                    <!-- <input
                                                        *ngIf="supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id]"
                                                        type="button"
                                                        (click)="openFileUploadModal(supportingDocumentsFormObject, 'fileBase64Data'+requiredDocument.id, 'fileType'+requiredDocument.id, false)"
                                                        class="preview_btn" value="Preview"> -->

                                                    <input
                                                        *ngIf="supportingDocumentsFormObject['fileBase64Data'+requiredDocument.id]"
                                                        type="button"
                                                        (click)="deleteUploadedFile(supportingDocumentsFormObject, 'fileBase64Data'+requiredDocument.id, 'fileType'+requiredDocument.id)"
                                                        class="delete_btn" value="Delete">
                                                </div>
                                            </div>
                                            <div *ngIf="supportingDocumentsForm.submitted && fileBase64Data.invalid"
                                                class="error-message">
                                                {{requiredDocument.documentLabel}} is required!
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div class="grid-third">
                                <!-- Dependent Documents Section -->
                                <div *ngFor="let dependent of dependentDocuments; let i = index" class="grid-third-box">
                                    <h3>Dependent {{ i + 1 }} Documents</h3>

                                    <div class="grid-third-box"
                                        *ngFor="let document of dependent.visaDocumentsDTOs; trackBy: trackByDocument; let j = index">
                                        <div class="upload_docs">
                                            <label class="fieldlabels label_doc">
                                                {{ document.documentLabel }}
                                                <span *ngIf="constants.TRUE" class="medatory">*</span>
                                            </label>

                                            <div class="input_box">

                                                <!-- Hidden input for validation binding -->
                                                <input type="hidden"
                                                    [name]="'fileBase64Data' + document.applicantId + '_' + document.id"
                                                    [required]="constants.TRUE"
                                                    [(ngModel)]="dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id]"
                                                    #dependentFileBase64Data="ngModel"
                                                    [ngModelOptions]="{ standalone: true }">

                                                <div class="file_uploads">
                                                    <div class="upload_box">
                                                        <!-- Default icon -->
                                                        <div *ngIf="!dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id]"
                                                            class="upload_icon">
                                                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                                        </div>

                                                        <span
                                                            *ngIf="!dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id]">
                                                            Files with Extension jpg, png, jpeg or pdf are allowed only.
                                                        </span>

                                                        <!-- Image preview -->
                                                        <img *ngIf="dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id] &&
                                                        dependentSupportingDocumentsFormObject['fileType' + document.applicantId + '_' + document.id] !== constants.FILE_TYPE_PDF"
                                                            [src]="dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id]">

                                                        <!-- PDF preview -->
                                                        <span
                                                            *ngIf="dependentSupportingDocumentsFormObject['fileType' + document.applicantId + '_' + document.id] === constants.FILE_TYPE_PDF">
                                                            <img src="assets/images/pdf.svg">
                                                        </span>
                                                    </div>

                                                    <!-- Action buttons -->
                                                    <div class="action-buttons">
                                                        <input
                                                            *ngIf="!dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id]"
                                                            type="button" (click)="openFileUploadModal(dependentSupportingDocumentsFormObject,
                                                            'fileBase64Data' + document.applicantId + '_' + document.id,
                                                            'fileType' + document.applicantId + '_' + document.id,
                                                            false)" class="upload_btn" value="Upload file">

                                                        <!-- <input
                                                            *ngIf="dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id]"
                                                            type="button" (click)="openFileUploadModal(dependentSupportingDocumentsFormObject,
                                                            'fileBase64Data' + document.applicantId + '_' + document.id,
                                                            'fileType' + document.applicantId + '_' + document.id,
                                                            false)" class="preview_btn" value="Preview"> -->

                                                        <input
                                                            *ngIf="dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id]"
                                                            type="button"
                                                            (click)="deleteUploadedFile(dependentSupportingDocumentsFormObject,
                                                                               'fileBase64Data' + document.applicantId + '_' + document.id,
                                                                               'fileType' + document.applicantId + '_' + document.id)"
                                                            class="delete_btn" value="Delete">
                                                    </div>
                                                </div>

                                                <!-- Error message -->
                                                <div *ngIf="supportingDocumentsForm.submitted && dependentFileBase64Data.invalid"
                                                    class="error-message">
                                                    {{ document.documentLabel }} is required!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>

                        <div class="grid-onethird-box">
                            <div class="instruction_box">
                                <h4>Instructions</h4>
                                <ng-template [ngTemplateOutlet]="instructions"></ng-template>
                            </div>
                        </div>
                    </div>

                    <input type="button" (click)="openPreviousFieldSet()" class="action-button-previous back_btn mt20"
                        value="Previous Page" />
                    <input type="button" (click)="saveAndExit()" class="save_btn" value="Save & Exit" />
                    <input type="submit" [disabled]="!supportingDocumentsForm.valid " class="action-button custom_btn"
                        value="Continue" />
                </form>

            </fieldset>


            <fieldset *ngIf="applicationStage === constants.TRAVEL_HISTORY_STEP">

                <div class="step_info">
                    <span>Step 5: {{applicationStepsList[5].label}}</span>
                </div>

                <form #travelHistoryForm="ngForm"
                    (ngSubmit)="travelHistoryForm.form.valid && openSecurityDetailsForm($event)"
                    name="travelHistoryForm" autocomplete="off" id="msform" errorFocus>

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="travelHistoryFormObject.hasFieldValueChanged" #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="travelHistoryFormObject.callableFunctionName" #callableFunctionName="ngModel">

                    <div class="grid-one-third">
                        <div class="grid-onethird-box">

                            <div class="grid-two">
                                <!-- Visa Issuance Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio mb30">
                                        <label class="fieldlabels">1. Have you been issued any visa for Nigeria,
                                            ECOWAS Member States, or African Union Countries in the last 5
                                            years?<span class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="issuedVisaLast5Years" [value]="false"
                                                [(ngModel)]="travelHistoryFormObject.issuedVisaLast5Years"
                                                class="infoyn" id="visaNo" required #issuedVisaLast5Years="ngModel" />
                                            <label for="visaNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="issuedVisaLast5Years" [value]="true"
                                                [(ngModel)]="travelHistoryFormObject.issuedVisaLast5Years"
                                                class="infoyn" id="visaYes" />
                                            <label for="visaYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="travelHistoryForm.submitted && issuedVisaLast5Years.invalid">
                                            <span *ngIf="issuedVisaLast5Years.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="travelHistoryFormObject.issuedVisaLast5Years">
                                            <label class="fieldlabels">Date of Issue:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.dateOfIssue"
                                                name="dateOfIssue" class="form-control" required
                                                #visaIssueDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && dateOfIssue.invalid">
                                                <span *ngIf="visaIssueDate.errors?.required">Date of issue is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Date of Expiry:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.dateOfExpiry"
                                                name="dateOfExpiry" class="form-control" required
                                                #visaExpiryDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && dateOfExpiry.invalid">
                                                <span *ngIf="dateOfExpiry.errors?.required">Date of expiry is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Issuing Authority:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.issuingAuthority"
                                                name="issuingAuthority" class="form-control" required
                                                #issuingAuthority="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && issuingAuthority.invalid">
                                                <span *ngIf="issuingAuthority.errors?.required">Issuing authority is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Travel to Nigeria Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">2. Have you ever travelled to Nigeria in the last
                                            5 years?<span class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="travelledToNigeria" [value]="false"
                                                [(ngModel)]="travelHistoryFormObject.travelledToNigeria" class="infoyn"
                                                id="travelNo" required #travelledToNigeria="ngModel" />
                                            <label for="travelNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="travelledToNigeria" [value]="true"
                                                [(ngModel)]="travelHistoryFormObject.travelledToNigeria" class="infoyn"
                                                id="travelYes" />
                                            <label for="travelYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="travelHistoryForm.submitted && travelledToNigeria.invalid">
                                            <span *ngIf="travelledToNigeria.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="travelHistoryFormObject.travelledToNigeria">
                                            <label class="fieldlabels">Date of Arrival:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.dateOfArrival"
                                                name="arrivalDate" class="form-control" required
                                                #arrivalDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && arrivalDate.invalid">
                                                <span *ngIf="arrivalDate.errors?.required">Arrival date is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Date of Departure:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.dateOfDeparture"
                                                name="departureDate" class="form-control" required
                                                #departureDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && departureDate.invalid">
                                                <span *ngIf="departureDate.errors?.required">Departure date is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Purpose of the Trip:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.tripPurpose"
                                                name="tripPurpose" class="form-control" required
                                                #tripPurpose="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && tripPurpose.invalid">
                                                <span *ngIf="tripPurpose.errors?.required">Trip purpose is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Refused Entry Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">3. Have you been refused entry into Nigeria in
                                            the last 5 years?<span class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="refusedEntry" [value]="false"
                                                [(ngModel)]="travelHistoryFormObject.refusedEntry" class="infoyn"
                                                id="refusedNo" required #refusedEntry="ngModel" />
                                            <label for="refusedNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="refusedEntry" [value]="true"
                                                [(ngModel)]="travelHistoryFormObject.refusedEntry" class="infoyn"
                                                id="refusedYes" />
                                            <label for="refusedYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="travelHistoryForm.submitted && refusedEntry.invalid">
                                            <span *ngIf="refusedEntry.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="travelHistoryFormObject.refusedEntry">
                                            <label class="fieldlabels">Date of Refusal:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.refusalDate"
                                                name="refusalDate" class="form-control" required
                                                #refusalDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && refusalDate.invalid">
                                                <span *ngIf="refusalDate.errors?.required">Refusal date is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Port of Entry or Border:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.portOfEntry"
                                                name="refusalPort" class="form-control" required
                                                #refusalPort="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && refusalPort.invalid">
                                                <span *ngIf="refusalPort.errors?.required">Port of entry is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Reason for Refusal:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.refusalReason"
                                                name="refusalReason" class="form-control" required
                                                #refusalReason="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && refusalReason.invalid">
                                                <span *ngIf="refusalReason.errors?.required">Reason is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Reference Number (if applicable):</label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.refusalRefNo"
                                                name="refusalRefNumber" class="form-control"
                                                #refusalRefNumber="ngModel" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Refused Visa Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">4. Have you been refused a visa for any country,
                                            including Nigeria, in the last 5 years?<span
                                                class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="visaRefusal" [value]="false"
                                                [(ngModel)]="travelHistoryFormObject.visaRefusal" class="infoyn"
                                                id="visaRefusedNo" required #visaRefusal="ngModel" />
                                            <label for="visaRefusedNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="visaRefusal" [value]="true"
                                                [(ngModel)]="travelHistoryFormObject.visaRefusal" class="infoyn"
                                                id="visaRefusedYes" />
                                            <label for="visaRefusedYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="travelHistoryForm.submitted && visaRefusal.invalid">
                                            <span *ngIf="visaRefusal.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="travelHistoryFormObject.visaRefusal">
                                            <label class="fieldlabels">Country of Visa Application:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.visaRefusalCountry"
                                                name="visaRefusedCountry" class="form-control" required
                                                #visaRefusedCountry="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && visaRefusedCountry.invalid">
                                                <span *ngIf="visaRefusedCountry.errors?.required">Country is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Type of Visa Refused:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.visaRefusalType"
                                                name="visaRefusedType" class="form-control" required
                                                #visaRefusedType="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && visaRefusedType.invalid">
                                                <span *ngIf="visaRefusedType.errors?.required">Visa type is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Date of Refusal:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.visaRefusalDate"
                                                name="visaRefusedDate" class="form-control" required
                                                #visaRefusedDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && visaRefusedDate.invalid">
                                                <span *ngIf="visaRefusedDate.errors?.required">Refusal date is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Reason for Refusal:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.visaRefusalReason"
                                                name="visaRefusedReason" class="form-control" required
                                                #visaRefusedReason="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && visaRefusedReason.invalid">
                                                <span *ngIf="visaRefusedReason.errors?.required">Reason is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Deportation or Removal Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">5. Have you been deported, removed, or otherwise
                                            required to leave any country, including Nigeria, in the last 10
                                            years?<span class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="deportedOrRemoved" [value]="false"
                                                [(ngModel)]="travelHistoryFormObject.deportedOrRemoved" class="infoyn"
                                                id="deportedNo" required #deportedOrRemoved="ngModel" />
                                            <label for="deportedNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="deportedOrRemoved" [value]="true"
                                                [(ngModel)]="travelHistoryFormObject.deportedOrRemoved" class="infoyn"
                                                id="deportedYes" />
                                            <label for="deportedYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="travelHistoryForm.submitted && deportedOrRemoved.invalid">
                                            <span *ngIf="deported.errors?.required">This field is required!</span>
                                        </span>

                                        <div *ngIf="travelHistoryFormObject.deportedOrRemoved">
                                            <label class="fieldlabels">Country:<span class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.deportedCountry"
                                                name="deportationCountry" class="form-control" required
                                                #deportationCountry="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && deportedCountry.invalid">
                                                <span *ngIf="deportationCountry.errors?.required">Country is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Date of Deportation/Removal:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.deportedDate"
                                                name="deportationDate" class="form-control" required
                                                #deportationDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && deportationDate.invalid">
                                                <span *ngIf="deportationDate.errors?.required">Date is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Port of Exit or Border:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.deportedPort"
                                                name="deportationPort" class="form-control" required
                                                #deportationPort="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && deportationPort.invalid">
                                                <span *ngIf="deportationPort.errors?.required">Port is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Reason for Deportation/Removal:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.deportedReason"
                                                name="deportationReason" class="form-control" required
                                                #deportationReason="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && deportationReason.invalid">
                                                <span *ngIf="deportationReason.errors?.required">Reason is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Travel Outside Country of Residence Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">6. Have you travelled outside your country of
                                            residence (excluding Nigeria) in the last 5 years?<span
                                                class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="travelledAbroad" [value]="false"
                                                [(ngModel)]="travelHistoryFormObject.travelledAbroad" class="infoyn"
                                                id="travelledAbroadNo" required #travelledAbroad="ngModel" />
                                            <label for="travelledAbroadNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="travelledAbroad" [value]="true"
                                                [(ngModel)]="travelHistoryFormObject.travelledAbroad" class="infoyn"
                                                id="travelledAbroadYes" />
                                            <label for="travelledAbroadYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="travelHistoryForm.submitted && travelledAbroad.invalid">
                                            <span *ngIf="travelledAbroad.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="travelHistoryFormObject.travelledAbroad">
                                            <label class="fieldlabels">Date of Travel:<span
                                                    class="medatory">*</span></label>
                                            <input type="date" [(ngModel)]="travelHistoryFormObject.abroadTravelDate"
                                                name="travelDate" class="form-control" required #travelDate="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && travelDate.invalid">
                                                <span *ngIf="travelDate.errors?.required">Travel date is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Country Visited:<span
                                                    class="medatory">*</span></label>
                                            <input type="text"
                                                [(ngModel)]="travelHistoryFormObject.abroadCountryVisited"
                                                name="countryVisited" class="form-control" required
                                                #countryVisited="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && countryVisited.invalid">
                                                <span *ngIf="countryVisited.errors?.required">Country is
                                                    required!</span>
                                            </span>

                                            <label class="fieldlabels">Purpose of Visit:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="travelHistoryFormObject.abroadPurpose"
                                                name="visitPurpose" class="form-control" required
                                                #visitPurpose="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="travelHistoryForm.submitted && visitPurpose.invalid">
                                                <span *ngIf="visitPurpose.errors?.required">Purpose is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <input type="button" (click)="openPreviousFieldSet()" class="action-button-previous back_btn mt20"
                        value="Previous Page" />
                    <input type="submit" (click)="setShallExitApplication(true)" class="save_btn" value="Save & Exit" />
                    <input type="submit" (click)="setShallExitApplication(false)" class="action-button custom_btn"
                        value="Continue" />
                </form>

            </fieldset>

            <fieldset *ngIf="applicationStage === constants.SECURITY_AND_CRIMINAL_HISTORY_STEP">

                <div class="step_info">
                    <span>Step 6: {{applicationStepsList[6].label}}</span>
                </div>

                <form #securityDetailsForm="ngForm"
                    (ngSubmit)="securityDetailsForm.form.valid && openBiometricDetailsForm($event)"
                    name="securityDetailsForm" autocomplete="off" id="msform" errorFocus>

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="securityFormObject.hasFieldValueChanged" #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="securityFormObject.callableFunctionName" #callableFunctionName="ngModel">

                    <div class="grid-one-third">
                        <div class="grid-onethird-box">
                            <div class="grid-two">
                                <!-- Criminal Convictions Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">1. Do you have any criminal convictions in any
                                            country (including spent/unspent convictions and traffic offences)?<span
                                                class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="criminalConviction" [value]="false"
                                                [(ngModel)]="securityFormObject.criminalConviction" class="infoyn"
                                                id="convictionsNo" required #criminalConviction="ngModel" />
                                            <label for="convictionsNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="criminalConviction" [value]="true"
                                                [(ngModel)]="securityFormObject.criminalConviction" class="infoyn"
                                                id="convictionsYes" />
                                            <label for="convictionsYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="securityFormObject.submitted && criminalConviction.invalid">
                                            <span *ngIf="criminalConviction.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="securityFormObject.criminalConviction">
                                            <label class="fieldlabels">Conviction Details:<span
                                                    class="medatory">*</span></label>
                                            <input type="text"
                                                [(ngModel)]="securityFormObject.criminalConvictionDetails"
                                                name="criminalConvictionDetails" class="form-control" required
                                                #criminalConvictionDetails="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="securityFormObject.submitted && criminalConvictionDetails.invalid">
                                                <span *ngIf="criminalConvictionDetails.errors?.required">Country is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Criminal Charges Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">2. Have you ever been charged in any country with a
                                            criminal offence for which you have not yet been tried in court (including
                                            traffic offences)?<span class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="pendingCharges" [value]="false"
                                                [(ngModel)]="securityFormObject.pendingCharges" class="infoyn"
                                                id="chargesNo" required #pendingCharges="ngModel" />
                                            <label for="chargesNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="pendingCharges" [value]="true"
                                                [(ngModel)]="securityFormObject.pendingCharges" class="infoyn"
                                                id="chargesYes" />
                                            <label for="chargesYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="securityFormObject.submitted && pendingCharges.invalid">
                                            <span *ngIf="pendingCharges.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="securityFormObject.pendingCharges">
                                            <label class="fieldlabels">Charged Details:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="securityFormObject.pendingChargesDetails"
                                                name="pendingChargesDetails" class="form-control" required
                                                #chargeCountry="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="securityFormObject.submitted && pendingChargesDetails.invalid">
                                                <span *ngIf="pendingChargesDetails.errors?.required"> charge details is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Terrorist Activities Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">3. Have you ever been involved in, supported, or
                                            encouraged terrorist activities in any country?<span
                                                class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="terrorismInvolvement" [value]="false"
                                                [(ngModel)]="securityFormObject.terrorismInvolvement" class="infoyn"
                                                id="terrorismNo" required #terrorismInvolvement="ngModel" />
                                            <label for="terrorismNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="terrorismInvolvement" [value]="true"
                                                [(ngModel)]="securityFormObject.terrorismInvolvement" class="infoyn"
                                                id="terrorismYes" />
                                            <label for="terrorismYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="securityFormObject.submitted && terrorismInvolvement.invalid">
                                            <span *ngIf="terrorismInvolvement.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="securityFormObject.terrorismInvolvement">
                                            <label class="fieldlabels"> Terrorism Involvement Details:<span
                                                    class="medatory">*</span></label>
                                            <input type="text"
                                                [(ngModel)]="securityFormObject.terrorismInvolvementDetails"
                                                name="terrorismInvolvementDetails" class="form-control" required
                                                #terrorismInvolvementDetails="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="securityFormObject.submitted && terrorismInvolvementDetails.invalid">
                                                <span *ngIf="terrorismInvolvementDetails.errors?.required">terrorism
                                                    involvement details is
                                                    required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Terrorist Views Question -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">4. Have you ever expressed views (publicly or
                                            privately) that justify or promote terrorist violence, or that may encourage
                                            others to commit terrorist or other serious criminal acts?<span
                                                class="medatory">*</span></label>

                                        <div class="radio-group">
                                            <input type="radio" name="terrorismViews" [value]="false"
                                                [(ngModel)]="securityFormObject.terrorismViews" class="infoyn"
                                                id="viewsNo" required #terrorismViews="ngModel" />
                                            <label for="viewsNo" class="infoyn">No</label>
                                        </div>

                                        <div class="radio-group">
                                            <input type="radio" name="terrorismViews" [value]="true"
                                                [(ngModel)]="securityFormObject.terrorismViews" class="infoyn"
                                                id="viewsYes" />
                                            <label for="viewsYes" class="infoyn">Yes</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="securityFormObject.submitted && terrorismViews.invalid">
                                            <span *ngIf="terrorismViews.errors?.required">This field is
                                                required!</span>
                                        </span>

                                        <div *ngIf="securityFormObject.terrorismViews">
                                            <label class="fieldlabels">Terrorism View Details:<span
                                                    class="medatory">*</span></label>
                                            <input type="text" [(ngModel)]="securityFormObject.terrorismViewsDetails"
                                                name="terrorismViewsDetails" class="form-control" required
                                                #terrorismViewsDetails="ngModel" />
                                            <span class="alert-danger"
                                                *ngIf="securityFormObject.submitted && terrorismViewsDetails.invalid">
                                                <span *ngIf="terrorismViewsDetails.errors?.required">terrorism views
                                                    details is required!</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <input type="button" (click)="openPreviousFieldSet()" class="action-button-previous back_btn mt20"
                        value="Previous Page" />
                    <input type="submit" (click)="setShallExitApplication(true)" class="save_btn" value="Save & Exit" />
                    <input type="submit" (click)="setShallExitApplication(false)" class="action-button custom_btn"
                        value="Continue" />
                </form>

            </fieldset>

            <fieldset *ngIf="applicationStage === constants.BIOMETRIC_INFORMATION_STEP">

                <div class="step_info">
                    <span>Step 6: {{applicationStepsList[6].label}}</span>
                </div>

                <form #biometricDetailsForm="ngForm"
                    (ngSubmit)="biometricDetailsForm.form.valid && openApplicationPreview($event)"
                    name="biometricDetailsForm" autocomplete="off" id="msform" errorFocus>

                    <input type="hidden" name="hasFieldValueChanged"
                        [(ngModel)]="biometricFormObject.hasFieldValueChanged" #hasFieldValueChanged="ngModel">

                    <input type="hidden" name="callableFunctionName"
                        [(ngModel)]="biometricFormObject.callableFunctionName" #callableFunctionName="ngModel">

                    <div class="grid-one-third">
                        <div class="grid-onethird-box">
                            <div class="grid-two">
                                <!-- Biometric Enrollment Method -->
                                <div class="form_box-1 mb30">
                                    <div class="radio">
                                        <label class="fieldlabels">
                                            To complete your visa application, you must provide your biometric
                                            information (fingerprints).
                                            Please choose your preferred method of biometric enrollment:
                                            <span class="medatory">*</span>
                                        </label>

                                        <div class="radio-group">
                                            <input type="radio" name="biometricMethod" [value]="true"
                                                [(ngModel)]="biometricFormObject.portOfEntryEnrollment" class="infoyn"
                                                id="portOfEntry" required #biometricMethod="ngModel" />
                                            <label for="portOfEntry" class="infoyn">Enroll at the Port of Entry</label>
                                        </div>

                                        <span class="alert-danger"
                                            *ngIf="biometricFormObject.submitted && biometricMethod.invalid">
                                            Please confirm biometric enrollment!
                                        </span>
                                    </div>
                                </div>






                            </div>
                        </div>

                        <div class="grid-onethird-box">
                            <div class="instruction_box">
                                <h4>Instructions</h4>
                                <ul>
                                    <li>Biometric enrollment is mandatory for visa processing</li>
                                    <li>Mobile app enrollment requires a compatible smartphone with fingerprint scanner
                                    </li>
                                    <li>Port of entry enrollment may require additional processing time</li>
                                    <li>Ensure your passport is available during biometric enrollment</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <input type="button" (click)="openPreviousFieldSet()" class="action-button-previous back_btn mt20"
                        value="Previous Page" />
                    <input type="submit" (click)="setShallExitApplication(true)" class="save_btn" value="Save & Exit" />
                    <input type="submit" (click)="setShallExitApplication(false)" class="action-button custom_btn"
                        value="Continue" />
                </form>

            </fieldset>

        </div>

    </section>

</div>

<app-footer></app-footer>